// extracted by mini-css-extract-plugin
export var burger = "navigation-module--burger--c5d6d";
export var navigation = "navigation-module--navigation--a9ba7";
export var navlink = "navigation-module--navlink--57b2c";
export var open = "navigation-module--open--78888";